import { useContext } from 'react';

import { EventBusContext } from '../providers/event-bus';

export const useEventBus = () => useContext(EventBusContext);
